import { render } from "./ControleProgramas.vue?vue&type=template&id=8924e414"
import script from "./ControleProgramas.vue?vue&type=script&lang=js"
export * from "./ControleProgramas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__